import { MapPin } from "lucide-react";
import { Reveal, StaggerGroup, staggerItem } from "../components/Motion";
import { motion } from "framer-motion";
import { PageHero } from "../components/PageHero";
import { CTASection } from "../components/CTASection";
import { Seo } from "../components/Seo";

const regions = [
  { region: "Greater Boston", towns: ["Boston", "Cambridge", "Somerville", "Medford", "Dorchester", "Roxbury"] },
  { region: "North Shore", towns: ["Beverly", "Lynn", "Peabody", "Danvers", "Saugus"] },
  { region: "South Shore", towns: ["Quincy", "Braintree", "Weymouth", "Hingham", "Milton", "Brockton", "Randolph"] },
  { region: "MetroWest", towns: ["Framingham", "Natick", "Waltham", "Wellesley", "Woburn"] },
  { region: "Central MA", towns: ["Worcester", "Shrewsbury", "Westborough", "Auburn", "Grafton", "Millbury"] },
  { region: "Merrimack Valley", towns: ["Lowell", "Lawrence", "Andover", "Haverhill", "Methuen", "Chelmsford"] },
];

export default function Areas() {
  return (
    <>
      <Seo title="Areas We Serve" description="Cummings & Co. manages residential rental properties across Greater Boston, the North & South Shore, MetroWest, Central MA and the Merrimack Valley." />
      <PageHero
        overline="Coverage across the Commonwealth"
        titleLines={["We know", "Massachusetts —", "block by block."]}
        subtitle="Local expertise in the neighborhoods that matter. If your property is in Massachusetts, chances are we already manage nearby."
      />

      <section className="border-b border-border">
        <div className="mx-auto max-w-[1400px] px-6 py-20 lg:px-10 lg:py-28">
          <StaggerGroup className="grid gap-px border border-border bg-border md:grid-cols-2 lg:grid-cols-3">
            {regions.map((r, i) => (
              <motion.div key={i} variants={staggerItem} className="bg-background p-8 transition-colors hover:bg-muted lg:p-10">
                <div className="flex items-center gap-3">
                  <MapPin className="h-5 w-5 text-accent" strokeWidth={1.5} />
                  <h3 className="font-serif text-2xl font-normal">{r.region}</h3>
                </div>
                <ul className="mt-6 flex flex-wrap gap-2">
                  {r.towns.map((t) => (
                    <li key={t} className="border border-border px-3 py-1.5 text-xs text-muted-foreground">{t}</li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </StaggerGroup>
          <Reveal delay={0.2}>
            <p className="mt-12 max-w-2xl text-muted-foreground">
              Don't see your town? We're always expanding. <span className="text-accent">Reach out</span> — we very likely cover your area.
            </p>
          </Reveal>
        </div>
      </section>

      <CTASection />
    </>
  );
}
